var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.4253 1.5V6.89573H16.5001L11.4253 1.5Z",
    fill: "#E9E9EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.85 18.5H2.15C1.97761 18.5 1.81228 18.4254 1.69038 18.2925C1.56848 18.1597 1.5 17.9795 1.5 17.7917V2.20833C1.5 2.02047 1.56848 1.8403 1.69038 1.70747C1.81228 1.57463 1.97761 1.5 2.15 1.5H9.95L14.5 6.45833V17.7917C14.5 17.9795 14.4315 18.1597 14.3096 18.2925C14.1877 18.4254 14.0224 18.5 13.85 18.5Z",
    fill: "#E9E9EA",
    stroke: "#E9E9EA",
    strokeWidth: 1.80484,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2V7.39573H15.0748",
    fill: "#E9E9EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2V7.39573H15.0748",
    stroke: "#E9E9EA",
    strokeWidth: 1.80484,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3501 11.5195H12.1499",
    stroke: "#E9E9EA",
    strokeWidth: 1.80484,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3501 14.6055H12.1499",
    stroke: "#E9E9EA",
    strokeWidth: 1.80484,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryInActive);
export default __webpack_public_path__ + "static/media/InventoryInActive.52e0c28f6fdb6344f96a0a7ea1c10464.svg";
export { ForwardRef as ReactComponent };